import { render } from "./ContentSection.vue?vue&type=template&id=c9346bbc"
const script = {}

import "./ContentSection.vue?vue&type=style&index=0&id=c9346bbc&lang=css"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__